import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "mt-2 border border-eorange-200 rounded-xl bg-eorange-50 overflow-hidden" };
const _hoisted_2 = { class: "px-4 py-3" };
const _hoisted_3 = { class: "flex items-center gap-2 mb-2" };
const _hoisted_4 = { class: "text-sm font-semibold text-eorange-700" };
const _hoisted_5 = {
    key: 0,
    class: "ml-auto rounded-full bg-red-100 px-2 py-0.5 text-[11px] font-semibold text-red-600"
};
const _hoisted_6 = { class: "space-y-1 text-xs text-gray-600" };
const _hoisted_7 = { class: "font-medium" };
const _hoisted_8 = { class: "font-medium" };
const _hoisted_9 = { key: 0 };
const _hoisted_10 = { class: "font-medium" };
const _hoisted_11 = { class: "font-medium" };
const _hoisted_12 = { class: "mt-2 space-y-1" };
import { computed } from 'vue';
import { IconFileDescription } from '@tabler/icons-vue';
import { translateApp } from '@/i18n';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DraftCard',
    props: {
        draft: {}
    },
    emits: ["open-draft"],
    setup(__props) {
        const props = __props;
        const totalParticipants = computed(() => props.draft.booking_items.reduce((sum, item) => sum + item.quantity_of_participants, 0));
        const unresolvedCount = computed(() => (props.draft.customer_id ? 0 : 1));
        const customerLabel = computed(() => {
            if (props.draft.customer_candidate?.full_name) {
                return props.draft.customer_candidate.full_name;
            }
            if (props.draft.customer_id) {
                return `#${props.draft.customer_id}`;
            }
            return translateApp('chatbot.auto.pending');
        });
        const serviceSummary = computed(() => {
            const first = props.draft.booking_items[0]?.service_name;
            if (!first)
                return String(props.draft.booking_items.length);
            if (props.draft.booking_items.length === 1)
                return first;
            return `${first} +${props.draft.booking_items.length - 1}`;
        });
        const dateRange = computed(() => {
            const dates = props.draft.booking_items
                .map((item) => item.start_datetime.split('T')[0])
                .filter((v, i, a) => a.indexOf(v) === i)
                .sort();
            if (dates.length === 0)
                return '';
            if (dates.length === 1)
                return formatDate(dates[0]);
            return `${formatDate(dates[0])} - ${formatDate(dates[dates.length - 1])}`;
        });
        function formatDate(iso) {
            const [year, month, day] = iso.split('-');
            return `${day}/${month}/${year}`;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_unref(IconFileDescription), {
                            size: 16,
                            class: "text-eorange-500"
                        }),
                        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("chatbot.auto.borrador_de_itinerario")), 1),
                        (unresolvedCount.value > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t("chatbot.auto.unresolved_count", { count: unresolvedCount.value })), 1))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("p", null, [
                            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("chatbot.auto.cliente")), 1),
                            _createTextVNode(" " + _toDisplayString(customerLabel.value), 1)
                        ]),
                        _createElementVNode("p", null, [
                            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("chatbot.auto.servicios")), 1),
                            _createTextVNode(" " + _toDisplayString(serviceSummary.value), 1)
                        ]),
                        (dateRange.value)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("chatbot.auto.fecha")), 1),
                                _createTextVNode(" " + _toDisplayString(dateRange.value), 1)
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("p", null, [
                            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("chatbot.auto.participantes")), 1),
                            _createTextVNode(" " + _toDisplayString(totalParticipants.value), 1)
                        ])
                    ]),
                    _createElementVNode("ul", _hoisted_12, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.draft.booking_items, (item) => {
                            return (_openBlock(), _createElementBlock("li", {
                                key: item.service_id,
                                class: "flex items-center gap-1.5 text-xs text-gray-700"
                            }, [
                                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "w-1 h-1 rounded-full bg-eorange-400 flex-shrink-0" }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(item.service_name), 1)
                            ]));
                        }), 128))
                    ])
                ]),
                _createElementVNode("button", {
                    type: "button",
                    class: "w-full px-4 py-2.5 text-sm font-medium text-eorange-700 bg-eorange-100 hover:bg-eorange-200 transition-colors border-t border-eorange-200",
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('open-draft', __props.draft)))
                }, _toDisplayString(_ctx.$t("chatbot.auto.revisar_borrador")), 1)
            ]));
        };
    }
});
